module.exports = __webpack_public_path__ + "static/media/slack-icon.82bb9a10.png";